<template>
  <div class="editPage">
    <qx-card :title="pageTitle">
      <BaseForm ref="baseForm" @pwdDialogSuccess="sub" @checkPwdByMsgDialogSuccess="sub" />
    </qx-card>
    <SubBtnBox @sub="sub" />
  </div>
</template>

<script>
import BaseForm from './base';
import SubBtnBox from 'components/subBtnBox';
import {
  // bankcardAccountPay,
  companyPayApprove,
} from 'api/getPay';
import pageDataMixin from '@qx/mixin/pageData';
export default {
  mixins: [
    pageDataMixin,
  ],
  components: {
    BaseForm,
    SubBtnBox,
  },
  data () {
    return {
      pageUrl: '/manage/getPay/writeOff/companyPay/pay',
      formComponents: ['baseForm'],
    };
  },
  methods: {
    // editApi: bankcardAccountPay,
    editApi: companyPayApprove,
  },
  async mounted () {
    this.getData();
  },
};
</script>

<style scoped lang="scss">
</style>
